<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="렌탈" @rental="rental" :type="'orderMain'"></Header>
    <!-- content(s) -->
    <div id="content" class="rental">
      <section>
        <div class="ac">
          <p class="txtXL">
            <strong>할인 혜택 없이</strong>
            <br />
            진행 하시겠어요?
          </p>
          <p class="txtM mt80">지금 회원가입하면 신규회원 쿠폰을 드립니다!</p>
          <ul class="couponList">
            <li>
              <a href="javascript:;" class="block bgColor0" @click="join">
                <div class="inner">
                  <!-- <span class="copy">렌탈 3만원&구매 3만원 할인 쿠폰</span> -->
                  <strong class="copy">10만원 쿠폰팩</strong>
                  <span class="desc">유효기간 발급일로부터 30일</span>
                </div>
              </a>
            </li>
          </ul>
        </div>

        <div class="btnArea mt20">
          <button type="button" class="btn_p" @click="join">회원가입하고 쿠폰받기</button>
        </div>

        <div class="mt60 ac">
          <button type="button" class="links" @click="startOrder">
            할인 받지 않고 진행하기
          </button>
        </div>
      </section>
    </div>
    <!-- content(e) -->
    <footer class="footer"></footer>
    <!-- content(e) -->
    <ConfirmPop @cancel="cancel" @confirm="confirm" v-if="confirmPop" @close="confirmPop = false">
      <p v-html="msg"></p>
    </ConfirmPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import { GO_HOME } from '@/store/message.type.js';
import ConfirmPop from '@/components/popup/ConfirmPop';
import { isEmpty } from '@/common/common.function';
export default {
  name: 'guestMain',
  components: {
    ConfirmPop,
  },
  // created() {
  //   window.onpopstate = function(event) {
  //     console.log(this.$route, window.history, 'location: ' + document.location + ', state: ' + JSON.stringify(event.state));
  //   };
  // },
  mounted() {
    this.request.orderCommInfo.productCode = this.$route.params.productCode;
    this.request.orderCommInfo.internalProdCode = this.$route.params.internalProdCode;
    this.request.orderCommInfo.colorCode = this.$route.params.colorCode;
    this.paramOrderId = this.$route.params.orderId;
  },
  data() {
    return {
      paramOrderId: '',
      productCode: null,
      msg: '',
      confirmPop: false,
      request: {
        conOrderInfo: {
          // 거주지 정보
          cellNum: '',
          conAddrCode: '',
          conAddrJibun: '',
          conAddrPost: '',
          conAddrRemark: '',
          conAddrRoad: '',
          customerName: '',
          localUserYn: '', // 내국인 여부. Y: 내국인
          sex: '',
          ssn: '',
          userIdentityComp: '', // 통신사 코드
        },
        installInfo: {
          // 설치지 정보
          installAddrCode: '',
          installAddrJibun: '',
          installAddrPost: '',
          installAddrRemark: '',
          installAddrRoad: '',
          installCellNum: '', // 배송연락처 휴대폰번호
          installReqDate: '', // 설치/배송 예상일 (형식: YYYYMMDD)
          installUserName: '', // 배송연락처 이름
        },
        joinInfo: {
          // 비회원의 경우 간편 회원가입. 회원이면 joinYn을 N으로 보내주세요.
          joinYn: '', // 간편렌탈 가입여부 (Y:체크됨, N:체크해제됨)
          password: '', // 비밀번호
          selectedAgree3: '', // 상품서비스 안내 등을 위한 선택 동의여부 (selectAgreeInfo 와 달리 Y/N으로 보내주세요)
          userId: '', // 아이디
        },
        orderCommInfo: {
          colorCode: '',
          productCode: '',
          internalProdCode: '',
          orderId: '', // 주문번호
          orderStatus: 'RSTA00PR', // 내부 상태 구분값 (RSTA00RP: 주문접수 완료, RSTA00PR: 사전주문접수)
          safekey: '', // 신용조회 후 발급받은 세이프키
          saleType: 'RORT00GE', // 주문구분 (렌탈: RORT00GE, 일시불: RORT00SE)
        },
        payInfo: {
          bankAccnt: '', // 계좌번호 (- 없이 숫자만)
          bankCode: '', // 은행코드
          cardExpireDate: '', // 카드 유효기간 (형식: MMYY)
          cardName: '', // 카드사코드
          cardNumber: '', // 카드번호 (- 없이 숫자만)
          cashNum: '', // 현금영수증 발급할 전화번호
          cashReqYn: '', // 현금영수증 발급여부 (Y: 발급, N: 발급안함)
          checkType: '', // 결제수단 구분 (RDUT00CM: 계좌, RDUT00CC: 카드)
          couponCd: '', // 쿠폰코드
          dueDate: '', // 결제일
          rmanCd: '', // 추천코드
          secureKeyPad: '', // 보안키패드 사용여부 (Y: 사용, N: 사용안함)
        },
        selectAgreeInfo: {
          agreeAppPush: 'SLAG0002',
          agreeCollection: 'SLAG0002',
          agreeCredit: 'SLAG0002',
          agreeDm: 'SLAG0002',
          agreeEmail: 'SLAG0002',
          agreeSms: 'SLAG0002',
          agreeTel: 'SLAG0002',
        },
      },
    };
  },
  methods: {
    startOrder() {
      ApiService.service('GET', '/order/id')
        .then(({ data }) => {
          this.request.orderCommInfo.orderId = isEmpty(this.paramOrderId) ? data.result : this.paramOrderId;
          console.log(this.request);
          this.$router.push({ name: 'guestStep1', params: { request: this.request } });
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    join() {
      this.$router.push({ name: 'joinStep1', params: { orderCommInfo: this.request.orderCommInfo } });
    },
    rental() {
      this.msg = GO_HOME;
      this.confirmPop = true;
    },
    cancel() {
      this.confirmPop = false;
    },
    confirm() {
      this.$router.replace('/');
    },
  },
};
</script>
